"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Podopolis = void 0;
var foundation_1 = require("@deqo/foundation");
var BackOffRetryLoop_1 = require("./BackOffRetryLoop");
var EventSourceBase_1 = require("./streaming/EventSourceBase");
var logger = foundation_1.Logger.get('podopolis.connection');
var defaultBackoffPolicy = {
    base: 500,
    multipler: 1.5,
    max: 10000
};
var Podopolis = /** @class */ (function (_super) {
    __extends(Podopolis, _super);
    function Podopolis(params) {
        var _this = _super.call(this) || this;
        _this.params = params;
        _this.conn = null;
        _this.retryLoop = null;
        _this.crashed = false;
        _this.startPingForConnection = function (conn) {
            var policy = _this.params.pingPolicy;
            if (!policy)
                return;
            var _a = __read(policy, 2), count = _a[0], every = _a[1];
            var pingAt = null;
            var pingId = null;
            var samples = [];
            var invoke = function () {
                if ((conn === null || conn === void 0 ? void 0 : conn.state) !== 'active')
                    return;
                pingAt = performance.now();
                pingId = conn.ping();
            };
            conn.on('pong', function (id) {
                if (id !== pingId)
                    return;
                var time = performance.now() - (pingAt !== null && pingAt !== void 0 ? pingAt : 0);
                samples.push(time);
                if (samples.length === count) {
                    _this.emit('ping', [time, foundation_1.Arr.avg(samples)]);
                    samples.splice(0, samples.length);
                    _this.scheduler.timeout('ping', every, invoke);
                }
                else {
                    _this.scheduler.timeout('ping', 1000, invoke);
                }
            });
            invoke();
        };
        _this.burden(_this.scheduler = new foundation_1.DestroyableScheduler(), _this.on('state', function () { return _this.retryIfNotAlready(); }), function () { return (0, foundation_1.destroySafe)(_this.conn); });
        return _this;
    }
    Object.defineProperty(Podopolis.prototype, "state", {
        get: function () {
            var _a, _b;
            if (this.crashed)
                return 'error';
            return (_b = (_a = this.conn) === null || _a === void 0 ? void 0 : _a.state) !== null && _b !== void 0 ? _b : 'waiting';
        },
        enumerable: false,
        configurable: true
    });
    Podopolis.prototype.start = function () {
        logger.log('Podopolis starting');
        this.retry();
    };
    Podopolis.prototype.onActiveConnection = function (callback) {
        var _this = this;
        var push = function () {
            if (_this.conn && _this.conn.state === 'active') {
                callback(_this.conn);
            }
        };
        push();
        return this.on('state', push);
    };
    Podopolis.prototype.waitForActiveConnection = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.state === 'active') {
                    return [2 /*return*/, this.conn];
                }
                return [2 /*return*/, new Promise(function (rs, _rj) {
                        var off = _this.on('state', function (x) {
                            if (x === 'active') {
                                off();
                                rs(_this.conn);
                            }
                        });
                    })];
            });
        });
    };
    Podopolis.prototype.retry = function (forceDrop) {
        var _this = this;
        var _a, _b;
        // Skip if already connected and not forceDrop
        if (((_a = this.conn) === null || _a === void 0 ? void 0 : _a.state) === 'active' && !forceDrop) {
            return;
        }
        // Cancel any existing retry loop, we are restarting
        if (this.retryLoop) {
            (0, foundation_1.destroySafe)(this.retryLoop);
            this.retryLoop = null;
        }
        if (this.conn) {
            (0, foundation_1.destroySafe)(this.conn);
            this.conn = null;
        }
        this.retryLoop = new BackOffRetryLoop_1.BackOffRetryLoop((_b = this.params.backoffPolicy) !== null && _b !== void 0 ? _b : defaultBackoffPolicy);
        this.retryLoop
            .run(function (attempt) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.tryConnect(attempt)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); })
            .then(function (conn) {
            if (!conn)
                return;
            _this.conn = conn;
            _this.conn.on('state', function () { return _this.emit('state', conn.state); });
            _this.emit('state', conn.state);
            _this.startPingForConnection(conn);
            _this.retryLoop = null;
        })
            .catch(function () { return _this.retryLoop = null; });
    };
    Podopolis.prototype.retryIfNotAlready = function () {
        var _this = this;
        this.scheduler.timeout('sr', 1, function () {
            if (_this.retryLoop)
                return;
            _this.retry();
        });
    };
    Podopolis.prototype.tryConnect = function (attempt) {
        return __awaiter(this, void 0, void 0, function () {
            var conn, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        logger.log('Connecting to podopolis; attempt', attempt);
                        this.emit('retrying', attempt);
                        return [4 /*yield*/, this.params.connectionFactory()];
                    case 1:
                        conn = _a.sent();
                        return [4 /*yield*/, conn.open()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, conn];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Podopolis;
}(EventSourceBase_1.EventSourceBase));
exports.Podopolis = Podopolis;
